module.exports = "/images/2888cf62d798c41e1673c63443b7acca.svg";